// src/services/api.js
import axios from 'axios';

const EUREKA_PACS_URL = process.env.REACT_APP_EUREKA_PACS_URL;

const API_URL = EUREKA_PACS_URL+'/token/generate-token';

export const getToken = async (username, password) => {
  try {
    const response = await axios.post(API_URL, {
      login: username,
      password: password
    });
    loadUser(username,response.data.token);
    return response.data.token;  // Retourne le token
  } catch (error) {
    console.error('Erreur lors de la connexion', error);
    return null;
  }
};

export const loadUser = async (username,token) => {
  try {
    const response = await axios.get( EUREKA_PACS_URL+'/users/'+username, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
     localStorage.setItem('tenant', response.data.etablissement.publicId);
    return  response.data;
  } catch (error) {
    console.error('Erreur lors de la connexion', error);
    return null;
  }
};



